'use strict';

const setAllRoles = (state, roles) => {
  state.roles = roles;
};

export default {
  setAllRoles
};
